import {decode, encode, getAllKeys, remove} from './ecrypt';

export {decode, encode, getAllKeys, remove};
